/*
 * @Author: Fan
 * @Date: 2020-04-14 17:58:39
 * @description:
 * @LastEditors: Fan
 */
import ShortText from "./ShortText";
import Radio from "./Radio";
import Checkbox from "./Checkbox";
import Dropdown from "./Dropdown";
import SequenceNo from "./SequenceNo";
import Create from "./Create";
import CreatedTime from "./CreatedTime";
import CreatedDeptId from "./CreatedDeptId";
import Modifier from "./Modifier";
import ModifiedTime from "./ModifiedTime";
import Owner from "./Owner";
import LongText from "./LongText";
import Calendar from "./Date"; // 日期
import Num from "./Number";
import Logic from "./Logic";
import Attachment from "./Attachment";
import ImageUpload from "./ImageUpload";
import SignatureUpload from "./SignatureUpload";
import Location from "./Location";
import Address from "./Address";
import StaffSelector from "./StaffSelector";
import StaffMultiSelector from "./StaffMultiSelector";
import DepartmentSelector from "./DepartmentSelector";
import DepartmentMultiSelector from "./DepartmentMultiSelector";
import Group from "./Group";
import Description from "./Description";
import Sheet from "./Sheet";
import Tabs from "./Tabs";
import RelevanceForm from "./RelevanceForm";
import RelevanceFormMulti from './RelevanceFormMulti';
import SheetStatistic from "./SheetStatistic";
import ReverseRelevance from "./ReverseRelevance";
import Label from "./Label";
import Title from "./Title";
// import Time from "./Time";
export default [
    SheetStatistic,
    Title,
    ShortText,
    Radio,
    Checkbox,
    Dropdown,
    SequenceNo,
    Create,
    CreatedTime,
    CreatedDeptId,
    Modifier,
    ModifiedTime,
    Owner,
    LongText,
    Calendar,
    Num,
    Logic,
    Attachment,
    ImageUpload,
    SignatureUpload,
    Location,
    Address,
    StaffSelector,
    StaffMultiSelector,
    DepartmentSelector,
    DepartmentMultiSelector,
    Group,
    Description,
    Sheet,
    Tabs,
    RelevanceForm,
    RelevanceFormMulti,
    ReverseRelevance,
    Label,
];
